var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-sidebar-arrow-right"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-arrow-right",
    clipPath: "url(#clip-sidebar-arrow-right)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15998",
    "data-name": "Group 15998",
    transform: "translate(-10603 -7355) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23944",
    "data-name": "Rectangle 23944",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(7355 -10627)",
    fill: "#f6f9fc",
    opacity: 0.004
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18430",
    "data-name": "Path 18430",
    d: "M4.923,4.4.613.093A.359.359,0,0,0,.105.6L4.161,4.655.105,8.711a.359.359,0,1,0,.508.508L4.923,4.91A.359.359,0,0,0,4.923,4.4Z",
    transform: "translate(7362.212 -10612.524) rotate(-90)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.a1f7e8f2393f410dd6215f43a80c6259.svg";
export { ForwardRef as ReactComponent };